import { generateAccessName, AccessKey } from "../../../../../access";

/**
 * Base keys of the access sections on this page.
 */
const ACCESS_SECTION: AccessKey[] = [
	AccessKey.SETTINGS,
	AccessKey.SETTINGS_SYSTEM_PERFORMANCE,
];

/**
 * Enum representing special keys for each tab on this page.
 */
enum TabKeys {
	OVERVIEW = "overview",
	INCIDENTS = "incidents",
	OPERATIONS = "operations",
	CLIENTS = "clients",
}

const generateAccessSection = (key: AccessKey): AccessKey[] => [
	...ACCESS_SECTION,
	key,
];

const ARR_ACCESS_PART_KEY: Record<TabKeys, AccessKey[]> = {
	[TabKeys.OVERVIEW]: generateAccessSection(
		AccessKey.SYSTEM_PERFORMANCE_OVERVIEW,
	),
	[TabKeys.INCIDENTS]: generateAccessSection(
		AccessKey.SYSTEM_PERFORMANCE_INCIDENTS,
	),
	[TabKeys.OPERATIONS]: generateAccessSection(
		AccessKey.SYSTEM_PERFORMANCE_OPERATIONS,
	),
	// Пока тот же ключ, что у Overview: не ломаем роли без нового права в БД.
	[TabKeys.CLIENTS]: generateAccessSection(
		AccessKey.SYSTEM_PERFORMANCE_OVERVIEW,
	),
};

type TabAccessNamesType = {
	[key in TabKeys]: string;
};

const TabAccessNames: TabAccessNamesType = Object.fromEntries(
	Object.entries(ARR_ACCESS_PART_KEY).map(([key, section]) => [
		key,
		generateAccessName(...section),
	]),
) as TabAccessNamesType;

export { TabKeys, TabAccessNames, ARR_ACCESS_PART_KEY };
